function StyleSelector({ styles, selectedStyle, onStyleSelect, isLoading }) {
  return (
    <section className="w-full mb-4">
      <h2 className="text-md font-semibold text-center mb-2 text-gray-700">Choose Your Style:</h2>
      
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {styles.map((style) => (
          <div
            key={style.name}
            onClick={() => !isLoading && onStyleSelect(style.name)}
            className={`bg-white rounded-md shadow-sm overflow-hidden transition duration-150 border flex flex-col ${
              isLoading 
                ? 'opacity-60 cursor-not-allowed' 
                : 'cursor-pointer hover:shadow-md hover:border-accent'
            } ${selectedStyle === style.name ? 'border-accent shadow-md ring-1 ring-accent ring-offset-1' : 'border-gray-200'}`}
          >
            {/* Image container with fixed height */}
            <div className="w-full h-24 bg-gray-100 flex items-center justify-center overflow-hidden">
              {style.preview ? (
                <img 
                  src={style.preview} 
                  alt={`${style.name} Preview`} 
                  className="max-w-full max-h-full object-contain"
                />
              ) : (
                <div className="flex items-center justify-center p-2">
                  <span className="text-lg">🖼️</span>
                </div>
              )}
            </div>
            
            {/* Text content */}
            <div className="p-1.5 text-center mt-auto">
              <h3 className="font-medium text-gray-800 text-xs truncate">{style.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default StyleSelector; 